// @ts-nocheck
import { isArray } from "lodash";
import { apiRequest } from "../../services/apiService";
import {
  FETCH_ESTIMATES_FAILURE,
  FETCH_ESTIMATES_REQUEST,
  FETCH_ESTIMATES_SUCCESS,
  FETCH_OLD_COMMENTS_REQUEST,
  FETCH_OLD_COMMENTS_SUCCESS,
  FETCH_OLD_COMMENTS_FAILURE,
  POST_COMMENT_REQUEST,
  POST_COMMENT_SUCCESS,
  POST_APPLIED_RATE_REQUEST,
  POST_APPLIED_RATE_SUCCESS,
  POST_APPLIED_RATE_FAILURE,
  APPROVE_EVENT_REQUEST,
  APPROVE_EVENT_SUCCESS,
  APPROVE_EVENT_FAILURE,
  REJECT_EVENT_REQUEST,
  REJECT_EVENT_SUCCESS,
  REJECT_EVENT_FAILURE,
  NEW_ESTIMATE_REQUEST,
  NEW_ESTIMATE_SUCCESS,
  NEW_ESTIMATE_FAILURE,
  APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST,
  APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS,
  APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE,
  EMPTY_CLIENT_ESTIMATE_LIST,
  GET_ALL_SUBMITTED_ESTIMATES_REQUEST,
  GET_ALL_SUBMITTED_ESTIMATES_FAILURE,
  GET_ALL_SUBMITTED_ESTIMATES_SUCCESS,
  UPDATE_PO_NUMBER_REQUEST,
  UPDATE_PO_NUMBER_SUCCESS,
  UPDATE_PO_NUMBER_FAILURE,
  POST_CLIENT_PREFERRED_RATE_AND_NOTES_REQUEST,
  POST_CLIENT_PREFERRED_RATE_AND_NOTES_SUCCESS,
  POST_CLIENT_PREFERRED_RATE_AND_NOTES_FAILURE,
  POST_APPLIED_RATE_EVENT_REQUEST_REQUEST,
  POST_APPLIED_RATE_EVENT_REQUEST_FAILURE,
} from "../constants/estimate";
import { alertDialogAciton } from "./auth";

// fetch all estimates
export const fetchAllEstimateAction = ({
  payload,
  params,
  successCallback,
  additionalData,
}) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_ESTIMATES_REQUEST,
      payload: additionalData,
    });
    const { response, error } = await apiRequest({
      method: "GET",
      // url: `getAllEventsEstimate?page=${payload?.page}&eventName=${payload?.searchStr || ""}`,
      url: `getAllEventsEstimate`,
      params,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: FETCH_ESTIMATES_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ESTIMATES_FAILURE });
    }
  };
};

// fetch estimates of specific client
export const fetchEstimatesOfSpecificClientAction = ({
  payload,
  params,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_ESTIMATES_REQUEST,
      payload: params?.eventName || "",
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getEventsEstimateOfSpecificClient/${getState()?.auth?.userId}`,
      params,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: FETCH_ESTIMATES_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ESTIMATES_FAILURE });
    }
  };
};

// empty estimate list
export const emptyEstimateClientListAction = () => {
  return async (dispatch) => {
    dispatch({
      type: EMPTY_CLIENT_ESTIMATE_LIST,
    });
  };
};

// fetch old comment messages
export const fetchOldCommentsAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_OLD_COMMENTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getEstimateComments/${payload?.eventId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_OLD_COMMENTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_OLD_COMMENTS_FAILURE });
    }
  };
};

// post comment
export const postCommentAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: POST_COMMENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addEstimateComment/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: POST_COMMENT_SUCCESS,
        payload: response?.data?.data?.estimateChat,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POST_COMMENT_SUCCESS });
    }
  };
};

// post applied rate
export const postAppliedRateAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: POST_APPLIED_RATE_REQUEST });
    dispatch({
      type: POST_APPLIED_RATE_EVENT_REQUEST_REQUEST,
      payload: payload?.data?.id,
    });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updatePositionForAppliedRate/${payload?.sessionId}`,
      data: payload.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: POST_APPLIED_RATE_SUCCESS });
      dispatch({ type: "UPDATE_APPLIED_RATE_OF_POSITION", payload });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POST_APPLIED_RATE_FAILURE });
      dispatch({ type: POST_APPLIED_RATE_EVENT_REQUEST_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// post applied rate in parallel
export const postAppliedRateInParalledAction = (
  payloads,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: POST_APPLIED_RATE_REQUEST });
    dispatch({
      type: POST_APPLIED_RATE_EVENT_REQUEST_REQUEST,
      payload: payloads?.data?.id,
    });
    try {
      const appliedRateData = {};

      payloads?.forEach((p) => {
        if (!isArray(appliedRateData[p?.sessionId])) {
          appliedRateData[p?.sessionId] = [];
        }

        appliedRateData[p?.sessionId]?.push({
          id: p?.data?.id,
          estimateAppliedRate: p?.data?.estimateAppliedRate,
        });
      });

      const requests = Object?.keys(appliedRateData)?.map((appliedKeys) =>
        apiRequest({
          method: "PUT",
          url: `updateMultiplePositionsForAppliedRate/${appliedKeys}`,
          data: {
            ids: appliedRateData[appliedKeys],
          },
          isToken: true,
        }),
      );

      const results = await Promise.all(requests);

      const hasError = results.some(
        ({ response, error }) => error || response?.status !== 200,
      );

      if (hasError) throw new Error("One or more requests failed");

      dispatch({ type: POST_APPLIED_RATE_SUCCESS });

      dispatch({
        type: "UPDATE_APPLIED_RATE_OF_MULTIPLE_POSITIONS",
        payload: payloads,
      });

      if (successCallback) successCallback();
    } catch (err) {
      dispatch({ type: POST_APPLIED_RATE_FAILURE });
      if (failureCallback) failureCallback(err);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Failed to update applied rate, please try again",
        }),
      );
    }
  };
};

// post client preferred rate
export const postClientPreferredRateAndNoteAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: POST_CLIENT_PREFERRED_RATE_AND_NOTES_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addClientPreferredRate`,
      data: payload.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: POST_CLIENT_PREFERRED_RATE_AND_NOTES_SUCCESS });
      dispatch({ type: "UPDATE_PREFERRED_RATE_AND_NOTES", payload });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POST_CLIENT_PREFERRED_RATE_AND_NOTES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// post applied contractor rate
export const postAppliedContractorRateAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: POST_APPLIED_RATE_REQUEST, payload: [payload?.data?.id] });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateContractorRateForSow/${payload?.sessionId}`,
      data: payload.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: POST_APPLIED_RATE_SUCCESS });
      dispatch({ type: "UPDATE_APPLIED_CONTRACTOR_RATE_OF_POSITION", payload });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POST_APPLIED_RATE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// post applied contractor rate in parallel
export const postAppliedContractorRateInParallelAction = (
  payloads,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({
      type: POST_APPLIED_RATE_REQUEST,
      payload: payloads?.map((p) => p?.data?.id),
    });

    try {
      const appliedRateData = {};

      payloads?.forEach((p) => {
        if (!isArray(appliedRateData[p?.sessionId])) {
          appliedRateData[p?.sessionId] = [];
        }

        appliedRateData[p?.sessionId]?.push({
          id: p?.data?.id,
          updatedContractorRate: p?.data?.updatedContractorRate,
          californiaContractorRate: p?.data?.californiaContractorRate,
        });
      });

      const requests = Object.keys(appliedRateData)?.map((sessionKey) =>
        apiRequest({
          method: "PUT",
          url: `updateMultipleContractorRateForSow`,
          params: { sessionId: sessionKey },
          data: {
            ids: appliedRateData?.[sessionKey],
          },
          isToken: true,
        }),
      );

      const results = await Promise.all(requests);

      const hasError = results.some(
        ({ response, error }) => error || response?.status !== 200,
      );

      if (hasError) throw new Error("One or more requests failed");

      dispatch({ type: POST_APPLIED_RATE_SUCCESS });

      dispatch({
        type: "UPDATE_APPLIED_CONTRACTOR_RATE_OF_MULTIPLE_POSITIONS",
        payload: payloads,
      });

      if (successCallback) successCallback();
    } catch (err) {
      dispatch({ type: POST_APPLIED_RATE_FAILURE });

      if (failureCallback) failureCallback(err);
    }
  };
};

// update po number
export const postPONumberAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PO_NUMBER_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `editEstimatePONumber`,
      data: payload.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: UPDATE_PO_NUMBER_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_PO_NUMBER_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// post terms and tax
export const postTermsAndTaxAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: POST_APPLIED_RATE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `update_Event_Terms_Tax`,
      data: payload.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: POST_APPLIED_RATE_SUCCESS });
      dispatch({ type: "UPDATE_TERMS_OF_EVENT", payload: payload?.data });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POST_APPLIED_RATE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// approve event action
export const approveEventAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `approveEvent/${payload?.eventId}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: APPROVE_EVENT_SUCCESS, payload: payload?.eventId });
      if (successCallback) {
        successCallback({
          eventInfo: response?.data?.data,
        });
      }
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPROVE_EVENT_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Event approval failed",
        }),
      );
    }
  };
};

// get submitted estimate data action
export const getSubmittedEstimateDataForApproveAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getSubmittedEstimate",
      params: {
        eventId: payload?.eventId,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      if (successCallback) successCallback(response?.data?.data?._id);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPROVE_EVENT_FAILURE });
      if (failureCallback) failureCallback();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Event approval failed",
        }),
      );
    }
  };
};

// approve event by client action
export const approveEventByClientAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `clientApproveEvent/${payload?.eventId}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS,
        payload: payload?.eventId,
      });
      if (successCallback) {
        successCallback({
          eventInfo: response?.data?.data,
        });
      }
    } else if (response?.status !== 200 || error) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "Failed to approve estimate",
        }),
      );
      dispatch({ type: APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE });
    }
  };
};

// reject event action
export const rejectEventAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: REJECT_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `rejectEvent/${payload?.eventId}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: REJECT_EVENT_SUCCESS, payload: payload?.eventId });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REJECT_EVENT_FAILURE });
    }
  };
};

// newEstimateRequest action
export const newEstimateRequestAction = ({ id, payload, successCallback }) => {
  return async (dispatch) => {
    dispatch({ type: NEW_ESTIMATE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `newEstimateRequest/${id}`,
      data: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: NEW_ESTIMATE_SUCCESS, payload: null });
      if (successCallback)
        successCallback({
          eventInfo: response?.data?.data,
        });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: NEW_ESTIMATE_FAILURE });
    }
  };
};

// get all submitted estimate action
export const getAllSubmittedEstimateAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_SUBMITTED_ESTIMATES_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllSubmittedEstimate",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_ALL_SUBMITTED_ESTIMATES_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_SUBMITTED_ESTIMATES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};